module.exports = __webpack_public_path__ + "img/bottom-list5.6bf9a0d6.png";